import React, { Dispatch, SetStateAction, useState } from 'react';

import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { TableColumn } from '../utils/types';

type TableColumnSelectionProps = {
  customColumns: string[];
  setCustomColumns: Dispatch<SetStateAction<string[]>>;
  mapCol: TableColumn<any>[];
  handleColumnSave: () => void;
  loading: boolean;
};

const TableColumnSelection: React.FC<TableColumnSelectionProps> = ({
  customColumns,
  setCustomColumns,
  handleColumnSave,
  mapCol,
  loading,
}) => {
  const [changed, setChanged] = useState(false);
  return (
    <div className="p-inputgroup w-max">
      <MultiSelect
        value={customColumns}
        options={mapCol}
        optionValue="header"
        optionLabel="header"
        onChange={e => {
          setCustomColumns(e.value);
          setChanged(true);
        }}
        maxSelectedLabels={0}
        placeholder="Columns"
        panelHeaderTemplate
        selectedItemsLabel="Columns"
      />
      <Button
        icon="pi pi-save"
        className={`p-inputgroup-addon transition-all transition-duration-400 p-button-${changed || loading ? "warning" : "success"}`}
        title="Save table columns"
        onClick={() => {
          handleColumnSave();
          setChanged(false);
        }}
        loading={loading}
      />
    </div>
  );
};

export default TableColumnSelection